@if (!isLoaded()) {
    <ap-native-app-skeleton></ap-native-app-skeleton>
}

@if (isLoaded()) {
    @if (isMobileBrowser() && canScan()) {
        @if (showMobileError) {
            <ap-notification status="error" data-bb="no-app-error">
                <ap-content key="native-app.open.mobile.app.error"></ap-content>
            </ap-notification>
        }
        <ap-button-link (click)="mobileAppButtonClicked()" [href]="mobileAppHref">{{
            'native-app.open.mobile.app' | apContent
        }}</ap-button-link>
        <p>{{ 'native-app.or' | apContent }}</p>
    }
    <div class="ap-native-app">
        @if (canScan()) {
            <ap-qr-code [data]="qrContent" [options]="qrOptions"></ap-qr-code>
            <ap-native-app-instructions></ap-native-app-instructions>
        }
        @if (isPickedUpByNativeApp()) {
            <ap-illustration
                width="185px"
                height="185px"
                name="aanmelden-mobiel"
                data-bb="native-app-follow-instructions"
            ></ap-illustration>
            <ap-content key="native-app.instruction.follow.instructions"></ap-content>
        }
        @if (hasTimedOut()) {
            <div
                (keyup.enter)="emitRetry()"
                class="ap-sign__native-app--qr-timed-out"
                data-bb="native-app-timeout"
                (click)="emitRetry()"
                tabindex="0"
            >
                <ap-icon name="redo" size="extra-large"></ap-icon>
                <ap-content class="ap-sign__native-app--qr-timed-out-content" key="native-app.instruction.timeout"></ap-content>
            </div>
            <ap-native-app-instructions></ap-native-app-instructions>
        }
    </div>
}

<div class="ap-native-app__buttons">
    @if (cancelText() && isLoaded()) {
        <ap-button data-bb="cancel" variant="secondary" (onClick)="emitCancel()">
            {{ cancelText() }}
        </ap-button>
    }
    @if (isPickedUpByNativeApp()) {
        <ap-button [text]="true" data-bb="rescan" (onClick)="rescan()">
            {{ 'native-app.rescan' | apContent }}
        </ap-button>
    }
</div>
